import React, { Fragment, useContext } from 'react'
import PropTypes from 'prop-types'
import { get, set, identity } from 'lodash'

import { Checkbox } from '../../Checkbox'
import FilterBarContext from '../context'
import SelectAllCheckbox from '../components/SelectAllCheckbox'
import { buildPathToValue, findSectionElement } from '../utils'

const CheckboxList = ({
  items,
  onChange,
  hierarchy,
  withSelectAll,
  onSelectAllClick
}) => {
  const { filters, t, serverSideT } = useContext(FilterBarContext)

  const onChangeHandler = (path) => (checked) => {
    onChange((filters, newSections) => {
      const clonedFilters = { ...filters }
      set(clonedFilters, path, checked)

      const clonedNewSections = [...newSections]
      const sectionElement = findSectionElement(clonedNewSections, path)

      sectionElement.value = checked

      return { clonedFilters, clonedNewSections }
    }, path)
  }

  return (
    <div>
      {withSelectAll && (
        <Fragment>
          <SelectAllCheckbox
            withLabel
            t={t}
            filters={filters}
            hierarchy={hierarchy}
            onCheckboxClick={onSelectAllClick}
          />
          <hr />
        </Fragment>
      )}
      {items.map(({ label, val, key }) => {
        const elementKey = key ?? val
        const pathToValue = buildPathToValue(hierarchy, elementKey)

        return (
          <Checkbox
            key={elementKey}
            id={`${hierarchy.join('-')}-${elementKey}`}
            labelText={serverSideT(label)}
            checked={get(filters, pathToValue)}
            onChange={onChangeHandler(pathToValue)}
          />
        )
      })}
    </div>
  )
}

CheckboxList.propTypes = {
  items: PropTypes.array,
  onChange: PropTypes.func,
  hierarchy: PropTypes.arrayOf(PropTypes.string),
  withSelectAll: PropTypes.bool,
  onSelectAllClick: PropTypes.func
}

CheckboxList.defaultProps = {
  items: [],
  onChange: identity,
  hierarchy: [],
  withSelectAll: false,
  onSelectAllClick: identity
}

export default React.memo(CheckboxList)
